export enum ClassStageEnum {
  minimumClassPre = 2,
  minimumClassEFAI = 5,
  minimumClassEFAF = 4,
  minimumClassEM = 3,
  minimumClassEJA = 2
}
